import script from "./StdPage.vue?vue&type=script&lang=js"
export * from "./StdPage.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__